import React, { useState } from "react";

const brokers = [
  { id: "exness", name: "Exness", minDeposit: "$10", notes: "Popular for Gold/FX, tight spreads." },
  { id: "icm", name: "IC Markets", minDeposit: "$200", notes: "ECN style, suitable for scalping." },
  { id: "tickmill", name: "Tickmill", minDeposit: "$100", notes: "Good for indices & FX swing." },
];

const OpenAccount = () => {
  const [selectedBroker, setSelectedBroker] = useState("exness");
  const [accountType, setAccountType] = useState("individual");
  const [baseCurrency, setBaseCurrency] = useState("USD");
  const [agree, setAgree] = useState(false);

  const currentBroker = brokers.find((b) => b.id === selectedBroker);

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Open Broker Account via CrunchAlpha IB</h1>
          <p className="page-subtitle">
            Investor baru diwajibkan membuka akun broker melalui IB resmi CrunchAlpha. All dana tetap berada
            di broker, bukan di CrunchAlpha.
          </p>
        </div>
      </header>

      <section className="section">
        <h2 className="section-title">1. Choose Partner Broker</h2>
        <div className="card">
          <div className="form-row">
            <label>Partner Broker</label>
            <select
              value={selectedBroker}
              onChange={(e) => setSelectedBroker(e.target.value)}
              className="input"
            >
              {brokers.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </select>
          </div>
          {currentBroker && (
            <div className="broker-highlight">
              <p>
                <strong>{currentBroker.name}</strong> &mdash; Min deposit {currentBroker.minDeposit}
              </p>
              <p className="muted">{currentBroker.notes}</p>
              <p className="muted">
                Account akan otomatis ter-tag IB CrunchAlpha (rebate & fee sharing sesuai model 70/20/10).
              </p>
            </div>
          )}
        </div>
      </section>

      <section className="section">
        <h2 className="section-title">2. Account Preferences</h2>
        <div className="card">
          <div className="form-row">
            <label>Account Type</label>
            <div className="chip-group">
              <button
                type="button"
                className={`chip ${accountType === "individual" ? "chip-active" : ""}`}
                onClick={() => setAccountType("individual")}
              >
                Individual
              </button>
              <button
                type="button"
                className={`chip ${accountType === "corporate" ? "chip-active" : ""}`}
                onClick={() => setAccountType("corporate")}
              >
                Corporate
              </button>
            </div>
          </div>
          <div className="form-row">
            <label>Base Currency</label>
            <div className="chip-group">
              <button
                type="button"
                className={`chip ${baseCurrency === "USD" ? "chip-active" : ""}`}
                onClick={() => setBaseCurrency("USD")}
              >
                USD
              </button>
              <button
                type="button"
                className={`chip ${baseCurrency === "EUR" ? "chip-active" : ""}`}
                onClick={() => setBaseCurrency("EUR")}
              >
                EUR
              </button>
              <button
                type="button"
                className={`chip ${baseCurrency === "IDR" ? "chip-active" : ""}`}
                onClick={() => setBaseCurrency("IDR")}
              >
                IDR
              </button>
            </div>
          </div>
          <p className="muted">
            Details lanjutan (leverage, jenis akun, dokumen KYC) akan diisi di halaman broker setelah you klik
            tombol lanjut di bawah.
          </p>
        </div>
      </section>

      <section className="section">
        <h2 className="section-title">3. Risk & IB Agreement</h2>
        <div className="card">
          <label className="checkbox-row">
            <input
              type="checkbox"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
            />
            <span>
              Saya memahami bahwa CrunchAlpha adalah platform copy trading and intelligence, bukan broker, and dana
              saya disimpan di broker partner.
            </span>
          </label>
          <label className="checkbox-row">
            <input type="checkbox" />
            <span>
              Saya setuju akun saya di-tag ke IB resmi CrunchAlpha for keperluan rebate, fee, and monitoring
              performa akun.
            </span>
          </label>
          <div className="actions">
            <button
              type="button"
              className="btn btn-primary"
              disabled={!agree}
              onClick={() => alert("Dummy: redirect ke halaman broker partner.")}
            >
              Continue to Broker Form
            </button>
          </div>
          <p className="muted">
            Tombol di atas saat ini dummy. Nanti backend akan menghasilkan link unik (deep-link) ke broker dengan IB
            code yang sesuai.
          </p>
        </div>
      </section>
    </div>
  );
};

export default OpenAccount;
